<template>


    <div>

        <v-alert type="info" :value="!hasJobs" class="ma-0">{{$t('erp.widgets.background_jobs.no_active_jobs_message')}}</v-alert>

        <v-list-item-group v-if="jobs.length != 0">

            <v-list-item three-line v-for="job in jobs">
                <v-list-item-content>
                    <v-list-item-title>{{job.job_name}}</v-list-item-title>
                    <v-list-item-subtitle>
                        <span v-if="job.time_left_seconds != null">{{$t('erp.label.time_left')}}: {{display_time(job.time_left_seconds)}}</span>
                        <span v-else>{{$t('erp.label.time_left')}}: ∞</span> |
                        {{$t('erp.widgets.background_jobs.last_activity')}}: {{job.time_last_activity| moment($t('erp.common.datetime_string'))}}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                        <v-progress-linear indeterminate v-if="job.job_progress_percent == null"></v-progress-linear>

                        <v-progress-linear v-else
                                           :buffer-value="job.job_progress_percent"
                                           :value="job.job_progress_percent"
                                           stream
                        ></v-progress-linear>

                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

        </v-list-item-group>

    </div>



</template>


<script>



    export default {


        name: 'backgroundJobsWidget.vue',
        wconf: {

            title: 'dashboard.widget.title.background_jobs',
            location: 'secondary',
            position: 50,
            active: true

        },

        data() {


            return {

                jobs: [],
                interval: null,

            }

        },

        methods: {


            display_time(seconds) {


                let label = seconds + ' ' + this.$t('common.seconds');

                if (seconds <= 3600 && seconds > 60) {

                    label = Math.round((seconds / 60)) + ' ' + this.$t('common.minutes');

                } else if (seconds > 3600) {

                    label = (seconds / 3600) + ' ' + this.$t('common.hours');

                }


                return label;


            },

            getTitle() {

                return this.$t('dashboard.widget.title.background_jobs')

            },

            getJobs: function () {


                var self = this;

                self.$http.get('api/erp/v2/info/background-jobs').then((result) => {



                    self.jobs = result.data.payload;



                });


            }

        },


        mounted: function () {


            var self = this;


            self.getJobs();

            self.interval = setInterval(function(){self.getJobs()},5000);


        },
        computed: {


            hasJobs: function(){

                var self = this;

                if(self.jobs.length == 0){


                    return false;

                }


                return true;

            }

        },
        destroyed:  function(){

            var self=this;



            clearInterval(self.interval);


        },
        created(){}



    }



</script>
